import React from 'react';

type IconProps = { className?: string };

export const ProfileUserIcon: React.FC<IconProps> = ({
  className = 'w-5 h-5',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
    />
  </svg>
);

export const ProfileSettingsIcon: React.FC<IconProps> = ({
  className = 'w-5 h-5',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z'
    />
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M15 12a3 3 0 11-6 0 3 3 0 016 0z'
    />
  </svg>
);

export const ProfileBellIcon: React.FC<IconProps> = ({
  className = 'w-5 h-5',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9'
    />
  </svg>
);

export const ProfileShieldIcon: React.FC<IconProps> = ({
  className = 'w-5 h-5',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
    />
  </svg>
);

export const ProfileBriefcaseIcon: React.FC<IconProps> = ({
  className = 'w-5 h-5',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m8 0H8m8 0v6a2 2 0 01-2 2H10a2 2 0 01-2-2V6'
    />
  </svg>
);

export const ProfileCameraIcon: React.FC<IconProps> = ({
  className = 'w-5 h-5',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z'
    />
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.75}
        d='M15 13a3 3 0 11-6 0 3 3 0 016 0z'
    />
  </svg>
);

export const ProfileEditIcon: React.FC<IconProps> = ({
  className = 'w-4 h-4',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z'
    />
  </svg>
);

export const ProfileCheckIcon: React.FC<IconProps> = ({
  className = 'w-4 h-4',
}) => (
  <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M5 13l4 4L19 7'
    />
  </svg>
);

export const ProfileLockIcon: React.FC<IconProps> = ({
  className = 'w-3.5 h-3.5',
}) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
    <rect x='3' y='11' width='18' height='11' rx='2' />
    <path d='M7 11V7a5 5 0 0 1 10 0v4' />
  </svg>
);

export const PROFILE_SECTION_ICONS: Record<
  string,
  React.FC<IconProps>
> = {
  personal: ProfileUserIcon,
  account: ProfileSettingsIcon,
  notifications: ProfileBellIcon,
  privacy: ProfileShieldIcon,
  candidate: ProfileBriefcaseIcon,
};
